var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"widgets__item btn btn--size",on:{"click":function($event){return _vm.resolvePath(_vm.fields)}}},[_vm._v("Досрочное погашение")])}
var staticRenderFns = []

export { render, staticRenderFns }